import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { TranslocoModule } from '@ngneat/transloco';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';

import { ProgressSpinnerModule } from '../core/progress-spinner/progress-spinner.module';

import { BlockedCallerComponent } from './blocked-caller/blocked-caller.component';
import { CallerInfoDialogComponent } from './caller-info-dialog/caller-info-dialog.component';

@NgModule({
  imports: [
    BlockedCallerComponent,
    ButtonModule,
    CallerInfoDialogComponent,
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatCardModule,
    MatInputModule,
    ProgressSpinnerModule,
    ReactiveFormsModule,
    ToastModule,
    TranslocoModule,
  ],
  exports: [],
})
export class CallModule {}
